import { InfoOutlined as InfoIcon } from '@mui/icons-material'
import { Chip, TextField, Tooltip } from '@mui/material'
import { FEEDBACK_CATEGORIES, FeedbackCategoryId } from '../../../api/models'
import styles from './RegenerateModalContent.module.css'

type RegenerateModalContentProps = {
  selectedCategories: FeedbackCategoryId[]
  onToggleCategory: (id: FeedbackCategoryId) => void
  feedbackText: string
  onFeedbackTextChange: (value: string) => void
  feedbackMaxLength: number
}

export default function RegenerateModalContent({
  selectedCategories,
  onToggleCategory,
  feedbackText,
  onFeedbackTextChange,
  feedbackMaxLength,
}: RegenerateModalContentProps) {
  return (
    <>
      <div>
        <p className={styles.feedbackLabel}>Quick feedback tags:</p>
        <div className={styles.feedbackChipsContainer}>
          {FEEDBACK_CATEGORIES.map(category => {
            const isSelected = selectedCategories.includes(category.id)
            return (
              <Tooltip key={category.id} title={category.hint} arrow>
                <Chip
                  label={category.label}
                  size='small'
                  variant='outlined'
                  onClick={() => onToggleCategory(category.id)}
                  className={isSelected ? styles.feedbackChipSelected : styles.feedbackChip}
                />
              </Tooltip>
            )
          })}
        </div>
      </div>
      <TextField
        multiline
        minRows={4}
        placeholder='Describe what should be improved, added or changed. Indicate clearly if any data gap or limitation is not relevant.'
        value={feedbackText}
        onChange={e => onFeedbackTextChange(e.target.value)}
        fullWidth
        variant='outlined'
        size='small'
      />
      <div className={styles.charCount} style={{ justifyContent: 'flex-end' }}>
        {feedbackText.length}/{feedbackMaxLength} characters
      </div>
      <div className={styles.infoCallout}>
        <InfoIcon className={styles.infoCalloutIcon} />
        <span>Regeneration runs in the background and may take a few minutes. The updated version will appear in your queue</span>
      </div>
    </>
  )
}
